
import { defineComponent } from 'vue'
import { mapMutations, mapState } from 'vuex'
import { getOptions } from '@/utils'
import AddDomainDialog from '@/components/dialogs/AddDomainDialog.vue'
import { lookupRedirectDomains } from '@/utils/lookups'

export default defineComponent({
  name: 'RedirectDomain',
  props: ['defaultOptions'],
  components: { AddDomainDialog },
  computed: mapState('campaignsModule', ['campaign', 'errors']),
  data: function() {
    return {
      showAddDomainDialog: false,
      redirectDomains: [...(this.defaultOptions.redirectDomains || [])],
    }
  },
  async mounted() {
    if (!this.campaign.redirectDomainId) {
      this.redirectDomains = await getOptions(
        this.redirectDomains as [],
        '',
        '/api/redirect-domains',
      )
      this.campaign.redirectDomainId = this.redirectDomains.find(
        (d: any) => d.id === 15,
      )?.id // our tracker
    }
  },
  methods: {
    ...mapMutations('campaignsModule', ['update']),
    async getRedirectDomains(value: string, update: Function) {
      await lookupRedirectDomains(this, value, update)
    },
  },
})
